import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonPadding: {
      padding: 10,
      margin: '15px 0px',
    },
    imgContainerInner: {
      position: 'relative',
    },
    imgContainerOuter: {
      marginTop: 15,
    },
    inputUpload: {
      display: 'none',
    },
    imageWrapper: {
      display: 'flex',
      justifyContent: 'center',
      height: '100%',
      width: '100%',
      borderRadius: 8,
    },
    closeButton: {
      position: 'absolute',
      top: 8,
      right: 8,
      opacity: 0.5,
      background: 'white',
      [theme.breakpoints.down('xs')]: {
        top: 0,
        right: 0,
        transform: 'scale(0.75, 0.75)',
      },
    },
  }),
);

export default useStyles;
